// MoamadContext.js
import React, { createContext, useContext, useState } from "react";

const ExtentionDocumentsContext = createContext();

export const ExtDateDocumentProvider = ({ children }) => {
  const [moamadsExtentionDatesDocuments, setMoamadsExtentionDatesDocuments] =
    useState([]);

  const updateMoamadsExtentionDatesDocuments = (newMoamadRep) => {
    setMoamadsExtentionDatesDocuments(newMoamadRep);
  };

  return (
    <ExtentionDocumentsContext.Provider
      value={{
        moamadsExtentionDatesDocuments,
        updateMoamadsExtentionDatesDocuments,
      }}
    >
      {children}
    </ExtentionDocumentsContext.Provider>
  );
};

export const useMoamadsExtentionDatesContext = () => {
  return useContext(ExtentionDocumentsContext);
};
